import React from 'react';
import exclamation from '../../images/exclamation.svg';

const ViewIcon = (table: any) => {
  const rowData = table.cell.getData();
  const value = table.cell.getValue();
  return (
    <>
      {rowData.is_autofilled === 1 ? (
        <p>
          {value} <img src={exclamation}></img>
        </p>
      ) : (
        <p>{value}</p>
      )}
    </>
  );
};

export default ViewIcon;
